import { RouteObject } from "react-router-dom";

import App from "./App";
import BaseLayout from "./components/layout/BaseLayout";
import RouteErrorBoundary from "./errors/RouteErrorBoundary";
import InvalidPage from "./pages/InvalidPage";
import RedactUploadPage from "./pages/RedactUploadPage";
import RedactWindowPage from "./pages/RedactWindowPage";

export const routes: RouteObject[] = [
    {
        path: "/",
        element: <App />,
        errorElement: <RouteErrorBoundary />,
        children: [
            {
                element: <BaseLayout />,
                children: [
                    { index: true, element: <RedactUploadPage /> },
                    { path: "redact", element: <RedactWindowPage /> },
                    { path: "*", element: <InvalidPage /> },
                ],
            },
        ],
    },
];

export default routes;
